import fetch from '@/utils/fetch'
import {API_PATH} from '@/config/env'
export const homeAdvertiseList = (objJson) => fetch(API_PATH + '/course/api/adv/list', objJson, 'POST')
export const homeCourseList = (objJson) => fetch(API_PATH + '/course/api/zone/course/list', objJson, 'POST')



// WEBPACK FOOTER //
// ./src/api/home.js